{
  "loan-disclosures": "Loan Disclosures",
  "assumption": "Assumption",
  "assumption-subtitle": "If you sell or transfer this property to another person, your lender",
  "assumption-option-1": "will allow assumption",
  "assumption-option-2": "will not allow assumption",
  "demand-feature": "Demand Feature",
  "demand-feature-subtitle": "Your loan",
  "demand-feature-option-1": "has a demand feature",
  "demand-feature-option-2": "no demand feature",
  "negative-amortization": "Negative Amortization",
  "negative-amortization-subtitle": "Under your loan terms, you",
  "negative-amortization-option-1": "have a negative amortization as a feature",
  "negative-amortization-option-2": "may have negative amortization",
  "negative-amortization-option-3": "not a feature of loan",
  "partial-payments": "Partial Payments",
  "partial-payments-subtitle": "Your lender",
  "partial-payments-option-1": "may accept partial payments",
  "partial-payments-option-2": "may hold them in a separate account",
  "partial-payments-option-3": "does not accept any partial payments",
  "escrow-account": "Escrow Account",
  "escrow-account-subtitle": "For now, your loan",
  "escrow-account-option-1": "has escrow",
  "escrow-account-option-2": "will not have escrow",
  "escrow-account-subtitle-will-not": "Because",
  "escrow-account-option-1-will-not": "escrow has declined",
  "escrow-account-option-2-will-not": "lender does not offer escrow"
}
